import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { Address } from './address'
import { addressActions } from './address.actions'
import * as fromAddress from './address.reducer'
import { AddressService } from './address.service'
import { of } from 'rxjs'
import { exhaustMap, map, catchError, switchMap, tap, take } from 'rxjs/operators'
import { normalizationActions } from 'src/app/shared/normalization/normalization.actions'
import { normalizeToSchema } from 'src/app/shared/normalization/normalization'
import { persistentUserRoleActions } from '../role/user-role/persistent-user-role/persistent-user-role.actions'
import { persistentUserRoleSelectors } from '../role/user-role/persistent-user-role/persistent-user-role.selector'

@Injectable()
export class AddressEffects extends ResourceEffects<Address> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public addressService: AddressService
  ) {
    super(fromAddress.FEATURE_NAME, addressService, addressActions, actions$)
  }
  onSetSelectedUserRole = createEffect(
    () =>
      this.actions$.pipe(
        ofType(persistentUserRoleActions.setSelectedUserRole),
        tap((action) =>{
          let userRole:any
          this.store.select(persistentUserRoleSelectors.selectSelectedUserRole).pipe(
            take(1)
            ).subscribe((user)=>{
              userRole=user
            })
            userRole&&this.store.dispatch(addressActions.resetState())})
      ),
    { dispatch: false }
  )
}
